import { EmptyState } from "@/components/ui";
import { useShellState } from "@/hooks/useShellState";
import type { RecentDeployment } from "@/types/api";

import { TaskRow } from "./TaskRow";

/** Scrollable list of the global task feed inside the bottom panel. */
export function TaskList({ items }: { items: RecentDeployment[] }) {
  const { selectedTask, openTask } = useShellState();

  if (items.length === 0) {
    return (
      <div className="px-3 py-4">
        <EmptyState size="compact" title="No tasks yet.">
          Deployments from all tenants will appear here.
        </EmptyState>
      </div>
    );
  }

  return (
    <ul className="divide-y divide-line/60">
      {items.map((d) => (
        <li key={`${d.tenantId}:${d.runId}`}>
          <TaskRow
            deployment={d}
            active={
              selectedTask?.tenantId === d.tenantId &&
              selectedTask?.runId === d.runId
            }
            onSelect={(dep) =>
              openTask({ tenantId: dep.tenantId, runId: dep.runId })
            }
          />
        </li>
      ))}
    </ul>
  );
}
